<form (click)="debugForm(constructor.name)" (keydown)="(null)">
  @if (isAdmin()) {
    <mat-form-field class="w-full">
      <mat-label class="font-semibold">Raison</mat-label>
      <mat-select [formField]="formTree.reason">
        @for (reason of entityReasonValues; track $index) {
          <mat-option [value]="reason">
            {{ reason | stateReasonDisplay }}
          </mat-option>
        }
      </mat-select>
      <mat-error>Raison invalide</mat-error>
    </mat-form-field>
    <mat-form-field class="w-full">
      <mat-label class="font-semibold">Note</mat-label>
      <textarea matInput [formField]="formTree.note" rows="3"></textarea>
      @if (formTree.note().errors().length) {
        <mat-error> La note doit contenir entre 10 et 150 caractères. </mat-error>
      }
    </mat-form-field>
  }
</form>
